<template>
	<transition
		name="transition"
		:duration="{ enter: 750, leave: 250 }"
	>
		<nav
			id="mobile-nav"
			v-if="isShowing"
			:style="{'--height': primaryMenuHeight + 'px'}"
		>
			<div
				class='touch-close'
				@click="toggleMobileMenu()"
			></div>
			<div class="mobile-menu">
				<div
					class="mobile-menu__inner"
					v-bind:style="{ height: primaryMenuHeight + 'px' }"
				>
					<div
						ref="menuDepth0"
						class="mobile-menu__panel mobile-menu__panel--depth-0"
						v-if="menuData"
						:class="{ current: depth == 0, previous: depth > 0 }"
					>
						<ul class="mobile-menu-links">
							<li v-if="showHomeLink">
								<a
									href="/"
									:class="{ selected: currentId <= 0 }"
								>Home</a>
							</li>

							<li
								v-for="post in menuData"
								:key="post.ID"
								:class="post.classes"
							>
								<div
									v-if="post.children && post.children.length > 0"
									:class="{
                    selected: post.object_id == currentId,
                  }"
									v-on:click.prevent="didSelectPost(post)"
									v-html="post.title"
								>
								</div>
								<a
									v-else
									:href="post.url"
									:class="{
                    selected: post.object_id == currentId,
                  }"
									v-html="post.title"
								>
								</a>

								<img
									v-if='post.children && post.children.length > 0'
									v-on:click.prevent="didSelectPost(post)"
									:src='arrow'
									alt='Has Children'
								/>
							</li>

						</ul>

					</div>

					<div
						ref="menuDepth1"
						class="mobile-menu__panel mobile-menu__panel--depth-1"
						v-if="menuForDepth1"
						:class="{
              current: depth == 1,
              previous: depth > 1,
              next: depth < 1,
            }"
					>
						<ul
							class="mobile-menu-links"
							v-if="selectedMenu0"
						>
							<li :key="selectedMenu0.ID">
								<a
									:href="selectedMenu0.url"
									v-on:click.prevent="didSelectPost(selectedMenu0, true)"
									v-html="selectedMenu0.title"
								>
								</a>
							</li>

							<li
								v-for="post in menuForDepth1"
								:key="post.ID"
								:class="post.classes"
							>
								<div
									v-if="post.children && post.children.length > 0"
									:class="{
                    selected: post.object_id == currentId,
                  }"
									v-on:click.prevent="didSelectPost(post)"
								>
									<span v-html="post.title"></span>
								</div>
								<a
									v-else
									:href="post.url"
									:class="{
                    selected: post.object_id == currentId,
                  }"
								>
									<img
										class="icon"
										v-if="post.icon"
										:src="post.icon"
										:alt="post.title"
									/>
									<span v-html="post.title"></span>
								</a>
								<img
									v-if='post.children && post.children.length > 0'
									v-on:click.prevent="didSelectPost(post)"
									:src='arrow'
									alt='Has Children'
								/>
							</li>
						</ul>

						<div
							v-if="selectedMenu0"
							class="mobile-menu-footer"
						>
							<a
								:href="selectedMenu0.url"
								v-on:click.prevent="didSelectBack()"
								class="back"
							><svg
									xmlns="http://www.w3.org/2000/svg"
									width="13.554"
									height="12.554"
									viewBox="0 0 13.554 12.554"
								>
									<g
										id="Arrow_Short"
										data-name="Arrow Short"
										transform="translate(0 0.53)"
									>
										<path
											id="Arrow-basic"
											d="M8.127,0V8.127H0"
											transform="translate(1 5.746) rotate(-45)"
											fill="none"
											stroke="#000"
											stroke-width="1.5"
										/>
										<line
											id="Line_251"
											data-name="Line 251"
											x1="12.5"
											transform="translate(0 5.796)"
											fill="none"
											stroke="#000"
											stroke-width="1.5"
										/>
									</g>
								</svg>

								<h5>Back</h5>
							</a>
						</div>
					</div>

					<div
						ref="menuDepth2"
						class="mobile-menu__panel mobile-menu__panel--depth-2"
						v-if="menuForDepth2"
						:class="{
              current: depth == 2,
              previous: depth > 2,
              next: depth < 2,
            }"
					>
						<ul
							class="mobile-menu-links"
							v-if="selectedMenu1"
						>
							<li :key="selectedMenu1.ID">
								<a
									v-html="selectedMenu1.title"
									:href="selectedMenu1.url"
									v-on:click.prevent="didSelectPost(selectedMenu1, true)"
								></a>
							</li>

							<li
								v-for="post in menuForDepth2"
								:key="post.ID"
								:class="post.classes"
							>
								<a
									:href="post.url"
									:class="{
                    selected: post.object_id == currentId,
                  }"
								><span v-html="post.title"></span></a>
								<img
									v-if='post.children && post.children.length > 0'
									v-on:click.prevent="didSelectPost(post)"
									:src='arrow'
									alt='Has Children'
								/>
							</li>
						</ul>

						<div
							v-if="selectedMenu1"
							class="mobile-menu-footer"
						>
							<a
								:href="selectedMenu1.url"
								v-on:click.prevent="didSelectBack()"
								class="back"
							><svg
									xmlns="http://www.w3.org/2000/svg"
									width="13.554"
									height="12.554"
									viewBox="0 0 13.554 12.554"
								>
									<g
										id="Arrow_Short"
										data-name="Arrow Short"
										transform="translate(0 0.53)"
									>
										<path
											id="Arrow-basic"
											d="M8.127,0V8.127H0"
											transform="translate(1 5.746) rotate(-45)"
											fill="none"
											stroke="#000"
											stroke-width="1.5"
										/>
										<line
											id="Line_251"
											data-name="Line 251"
											x1="12.5"
											transform="translate(0 5.796)"
											fill="none"
											stroke="#000"
											stroke-width="1.5"
										/>
									</g>
								</svg>

								<h5>Back</h5>
							</a>
						</div>
					</div>

					<div
						ref="menuDepth3"
						class="mobile-menu__panel mobile-menu__panel--depth-3"
						v-if="menuForDepth3"
						:class="{ current: depth == 3, next: depth < 3 }"
					>
						<ul class="mobile-menu-links">
							<li
								v-for="post in menuForDepth3"
								:key="post.ID"
								:class="post.classes"
							>

								<a
									:href="post.url"
									:class="{
                    selected: post.object_id == currentId,
                  }"
								>
									<span v-html="post.title"></span>
								</a>

								<img
									v-if='post.children && post.children.length > 0'
									v-on:click.prevent="didSelectPost(post)"
									:src='arrow'
									alt='Has Children'
								/>

							</li>
						</ul>

						<div
							v-if="selectedMenu2"
							class="mobile-menu-footer"
						>
							<a
								:href="selectedMenu2.url"
								v-on:click.prevent="didSelectBack()"
								class="back"
							><svg
									xmlns="http://www.w3.org/2000/svg"
									width="13.554"
									height="12.554"
									viewBox="0 0 13.554 12.554"
								>
									<g
										id="Arrow_Short"
										data-name="Arrow Short"
										transform="translate(0 0.53)"
									>
										<path
											id="Arrow-basic"
											d="M8.127,0V8.127H0"
											transform="translate(1 5.746) rotate(-45)"
											fill="none"
											stroke="#000"
											stroke-width="1.5"
										/>
										<line
											id="Line_251"
											data-name="Line 251"
											x1="12.5"
											transform="translate(0 5.796)"
											fill="none"
											stroke="#000"
											stroke-width="1.5"
										/>
									</g>
								</svg>

								<h5>Back</h5>
							</a>
						</div>
					</div>
				</div>
			</div>
			<!-- <div
				class="overlay"
				:class="{'visible': isShowing}"
			></div> -->
		</nav>
	</transition>
</template>

<script>
import Arrow from '../../images/arrow-basic.svg';

export default {
	data() {
		return {
			selectedPrimaryPost: null,
			selectedSecondaryPost: null,
			selectedTertiaryPost: null,
			selectedMenuData: null,
			arrow: Arrow,
			searchQuery: '',

			depth: 0,
			primaryMenuHeight: 300,

			selectedMenu0: null,
			selectedMenu1: null,
			selectedMenu2: null,
			selectedMenu3: null,
			// isShowingMenu: this.isShowingMenu ? this.isShowingMenu : false,
		};
	},

	props: {
		menuData: {
			type: Array,
			default: function () {
				return [];
			},
		},
		globalSettings: {},
		currentId: {
			type: Number,
			default: -1,
		},
		isShowing: {
			type: Boolean,
			default: false,
		},
		showHomeLink: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		menuForDepth1: function () {
			return this.selectedMenu0 ? this.selectedMenu0.children : [];
		},
		menuForDepth2: function () {
			return this.selectedMenu1 ? this.selectedMenu1.children : [];
		},
		menuForDepth3: function () {
			return this.selectedMenu2 ? this.selectedMenu2.children : [];
		},
	},

	watch: {
		// depth: function (newValue, oldValue) { // eslint-disable-line no-unused-vars
		//   //this.layoutSubviews();
		// },
		// isShowing: function (newValue, oldValue) {
		//   // if(newValue) {
		//   //
		//   // }
		// },
	},

	methods: {
		toggleMobileMenu() {
			this.$store.commit('toggleMobileMenu', !this.$store.state.mobile_menu);
		},

		layoutSubviews: function () {
			var height = 0,
				panelEl = this.$refs['menuDepth' + this.depth];

			if (typeof panelEl === 'undefined') return;

			height = panelEl.clientHeight;
			this.primaryMenuHeight = height;
		},
		didSelectBack: function () {
			if (this.depth > 0) {
				this.depth -= 1;
			}
		},
		didSelectPost: function (item, ignoreChildren = false) {
			const self = this;

			if (item.children && !ignoreChildren) {
				var newDepth = item.depth + 1;

				switch (newDepth) {
					case 1:
						{
							self.selectedMenu0 = item;
						}
						break;

					case 2:
						{
							self.selectedMenu1 = item;
						}
						break;

					case 3:
						{
							self.selectedMenu2 = item;
						}
						break;

					default:
				}

				self.depth = newDepth;

				return;
			}

			window.location.href = item.url;
			// self.isShowingMenu = false;
		},
	},

	components: {
		//PoseTransition,
	},

	mounted() {
		var self = this;
		setTimeout(function () {
			self.layoutSubviews();
		}, 150);
	},

	updated() {
		this.layoutSubviews();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

$mobile-menu-item-min-height: 72px;
$mobile-menu-footer-min-height: 82px;

/* .overlay {
	position: absolute;
	z-index: var(--z-index-bottom);
	top: 0;
	right: 0;
	bottom: 100%;
	left: 0;
	width: 100%;
	height: 100vh;
	background: rgba(0, 0, 0, 0.5);
	pointer-events: none;
	opacity: 0;
	pointer-events: none;

	&.visible {
		opacity: 1;
	}
} */

#mobile-nav {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 55;
	-webkit-overflow-scrolling: touch;

	.touch-close {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
	}

	.scrolled & {
		position: fixed;
		/* top: 84px;
		background-color: transparent;
		height: var(--height);

		&::before {
			content: '';
			position: absolute;
			top: -84px;
			left: 0;
			right: 0;
			height: 84px;
			background: var(--chartruese-green);
		}

		.mobile-menu {
			background-color: var(--chartruese-green);

			&__inner {
				background-color: var(--chartruese-green);
			}
		} */
	}

	/* .admin-bar & {
		//top: $header-height-xs + $admin-bar-height-xs;
		padding-top: $header-height-xs + $admin-bar-height-xs;

		@media (max-width: $tablet) {
			//top: $header-height-xs + $admin-bar-height;
			padding-top: $header-height-xs + $admin-bar-height;
		}
	} */

	&.fade-enter-active,
	&.fade-leave-active {
		transition: opacity 0.25s;

		.container {
			transition: transform 0.25s;
		}
	}

	&.fade-enter,
	&.fade-leave-to {
		opacity: 0;
	}

	&.fade-leave-to {
		.container {
			transform: translateY(-10px);
		}
	}

	&.transition-enter-active,
	&.transition-leave-active {
		transition: background 0.15s ease-in-out, opacity 0.1s ease-in-out;

		.mobile-menu {
			transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
		}
	}

	&.transition-enter-active {
		.mobile-menu {
			transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);

			.page-showing-menu & {
				transition-delay: 0.25s;
			}
		}
	}

	&.transition-leave-active {
		.mobile-menu {
			transition-duration: 0.25s;
			transition-timing-function: cubic-bezier(0.36, 0, 0.22, 0);
		}
	}

	&.transition-enter,
	&.transition-leave-to {
		/* background-color: var(--gum-green); */

		.mobile-menu {
			//opacity: 0;
			transform: translateX(120%);
		}
	}

	.mobile-menu {
		/* position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0; */
		/* overflow: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between; */
		background: transparent;
		transition: 0.2s ease all;
		justify-content: flex-end;
		display: flex;
		position: relative;
		pointer-events: none;

		&__inner {
			position: relative;
			overflow: hidden;
			background: var(--warm-grey);
			color: var(--gum-green);
			transition: 0.2s ease all;
			height: 100vh !important;
			width: calc(100vw - 80px) !important;
			right: 0;
			/* border-left: var(--border); */
			pointer-events: all;

			.back {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				/* min-height: $mobile-menu-footer-min-height; */
				position: relative;
				text-decoration: none;
				color: var(--gum-green);
				opacity: 1;
				gap: 9.5px;
				font: normal normal bold 15px/20px var(--primary-font-family);
				text-transform: uppercase;
				letter-spacing: 0.14px;
				padding: 24px 0 24px;

				h5 {
					font: normal normal normal 15px/20px var(--primary-font-family);
					text-transform: uppercase;
				}

				&:hover,
				&:active {
					text-decoration: none;
					opacity: 1;
				}

				svg {
					transform: rotate(-180deg);

					path {
						stroke: var(--gum-green);
					}

					line {
						stroke: var(--gum-green);
					}
				}
			}
		}

		&__panel {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			z-index: $z-index-low;
			transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
			margin-top: 91px;

			.scrolled & {
				margin-top: 56px;
			}

			body.logged-in &,
			body.admin-bar & {
				margin-top: 48px + 32px;

				@media (max-width: $mobile-xl) {
					margin-top: 48px + 41px;
				}
			}

			&.next {
				pointer-events: none;
				transform: translateX(50%);
				opacity: 0;
			}

			&.current {
				pointer-events: all;
				transform: translateX(0);
				opacity: 1;
				z-index: $z-index-medium;
			}

			&.previous {
				pointer-events: none;
				transform: translateX(-50%);
				opacity: 0;
			}

			.mobile-menu-footer {
				// border-top: solid 1px white;
				padding: 0 $page-gutter-width-xs;
			}

			.mobile-menu-links {
				list-style: none;
				margin: 0;
				padding: 20px $page-gutter-width-xs 16px $page-gutter-width-xs;

				> li {
					margin: 0;
					padding: 0;
					display: block;
					border-bottom: var(--border-blue);
					display: flex;
					justify-content: space-between;

					&:first-child {
						border-top: none;
					}

					> img {
						padding: 16px 0 16px 32px;

						&:hover {
							cursor: pointer;
						}
					}

					> a,
					> div {
						position: relative;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						/* min-height: $mobile-menu-item-min-height; */
						color: var(--gum-green);
						opacity: 1;
						text-decoration: none;
						padding: 16px 0 16px;
						width: 100%;
						column-gap: 16px;
						text-transform: uppercase;

						&:hover,
						&:active {
							text-decoration: none;
							opacity: 1;
							cursor: pointer;

							&::before {
								opacity: 1;
								//background-color: map-get($theme-colours, ocean-blue);
							}

							&::after {
								transform: translateX(5px);
							}
						}

						&.selected {
							//color: map-get($theme-colours, ocean-blue);
							opacity: 0.7;

							&.has-children {
								&:hover,
								&:active {
									text-decoration: none;
								}
							}
						}
					}
				}

				.site_button {
					margin-top: 40px;
				}
			}

			&--depth-1,
			&--depth-2,
			&--depth-3,
			&--depth-4 {
				.mobile-menu-links {
					padding: 0 $page-gutter-width-xs 0 $page-gutter-width-xs;

					> li {
						border-bottom: none;

						a {
							padding: 24px 0 16px;
						}

						span {
							font: normal normal normal 15px/20px var(--primary-font-family);
							text-transform: uppercase;
						}

						&:first-child {
							/* border-bottom: var(--border); */
							padding-top: 16px;
							padding-bottom: 16px;

							a {
								border: none;
								opacity: 1;
								font: normal normal normal 15px/20px var(--primary-font-family);
								letter-spacing: 0px;
								color: var(--gum-green);
								text-transform: uppercase;
							}
						}

						&:last-child {
							> a {
								padding: 10px 0 16px 0;
							}
						}

						> a {
							opacity: 1;
							color: var(--gum-green);
							text-transform: none;
							min-height: auto;
							padding: 10px 0;
						}

						/* &:not(:first-child) {
							border-top: 0;
						} */
					}
				}
			}
		}

		&__footer {
			text-align: center;
			padding: 0 $page-gutter-width-xs;
			// padding-top: ($grid-gutter-width/2);
			// padding-bottom: 0;

			.search-box {
				margin-bottom: ($grid-gutter-width/2);
			}

			.social {
				justify-content: flex-start;
				margin-bottom: ($grid-gutter-width/2);
			}
		}
	}
}

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MobileMenu.vue